<!--  -->
<template>
  <div></div>
</template>

<script>
export default {
  name: "component_name",
  data() {
    return {};
  },

  components: {},

  created() {
    window.location.href = "https://login.gov.taipei";
  },
  methods: {},

  computed: {},
};
</script>
<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/href.vue